import { createApi } from '@reduxjs/toolkit/query/react'
import { rtkBaseQuery } from 'Src/api'

export const accountApi = createApi({
  baseQuery: rtkBaseQuery,
  reducerPath: 'accountApi',
  tagTypes: ['Account'],
  refetchOnMountOrArgChange: 5,
  endpoints: (builder) => ({
    getAccount: builder.query({
      query: () => '/v1/account/',
      providesTags: ['Account']
    }),
    updateAccount: builder.mutation({
      query: (payload) => {
        return {
          url: '/v1/account/',
          method: 'PATCH',
          body: payload
        }
      },
      invalidatesTags: ['Account']
    }),
    updateOnboardingData: builder.mutation({
      query: (payload) => {
        return {
          url: '/v1/account/onboarding',
          method: 'POST',
          body: payload
        }
      },
      invalidatesTags: ['Account']
    }),
    switchAccount: builder.mutation({
      query: ({ id, email }) => {
        return {
          url: `/v1/accounts/${id}/switch`,
          method: 'POST',
          body: {
            email
          }
        }
      },
      invalidatesTags: ['Account']
    })
  })
})

export const {
  useGetAccountQuery,
  useUpdateAccountMutation,
  useUpdateOnboardingDataMutation,
  useSwitchAccountMutation
} = accountApi

export default accountApi
